import React from "react";
// import "../css/home.css";
import "../pages/home/css/home.css";

// const Loader: React.FC<{ message?: string }> = ({ message = "Loading..." }) => {
//   return (
//     <div className="fixed top-0 left-0 w-full h-full z-[9999] flex items-center justify-center bg-black bg-opacity-50">
//       <div className="flex flex-col items-center">
//         {/* Spinner */}
//         <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin" />
//         {/* Message */}
//         <p className="mt-4 text-white text-lg font-medium">{message}</p>
//       </div>
//     </div>
//   );
// };

// export default Loader;
const Loader: React.FC<{ message?: string }> = ({ message = "" }) => {
  return (
    <>
      <div className="fixed top-0 left-0 w-full h-screen bg-black/90 flex  justify-center items-center z-999">
        <div className="relative site-wrapper sm:translate-x-0 translate-x-[25%] ">
          <div className="site-wrapper-item bg-skyblue top"></div>
          <div className="site-wrapper-item bg-skyblue left"></div>
          <div className="site-wrapper-item bg-skyblue right"></div>
          <div className="site-wrapper-item bg-skyblue bottom"></div>
          <div className="absolute -bottom-8 -left-4 flex items-center text-white/80 text-sm font-normal animate-ping">Compiling Bits ... </div>
        </div>
      </div>
    </>
  );
};

export default Loader;
